import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-amber-50 py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-249" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-250" data-mp="3fxb22ggddmb4">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-251" data-mp="3azjcht376ca3">
          Testimonials from educators using this teacher ready
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-252" data-mp="31zd1cduz1oe3">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-id="element-253" data-mp="2x1l0uvg9gtya" data-mpi={index}>
              <div className="flex text-amber-500" aria-label="5 out of 5 stars" data-id="element-254" data-mp="h4dcylqnjo46">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-255" data-mp="77s8q2mgih1e" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-stone-600" data-id="element-256" data-mp="c6252gjx3nol">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-stone-100 pt-4" data-id="element-257" data-mp="zxh9cev98f2h">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-green-900 text-sm font-extrabold text-amber-400" data-id="element-258" data-mp="14vskqu176xmt">
                  {initials}
                </span>
                <span data-id="element-259" data-mp="v4xvdgsnnhx5">
                  <b className="block text-sm text-green-950" data-id="element-260" data-mp="v44wt33unyq3">{name}</b>
                  <small className="text-xs text-stone-500" data-id="element-261" data-mp="1iv1x1ima97li">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}